import React from 'react';

export default function PrivacyPolicy() {
  
   React.useEffect(() => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    }, []);

  return (
    <section className="privacy-policy-page">
      <div className="container privacy-policy-card">
        <div className="privacy-policy-header text-center mb-5">
          <h2>Privacy Policy</h2>
          <p className="privacy-policy-revised" style={{ textAlign: 'center' }}>
            Last Revised: 05-31-2026
          </p>
          <p className="privacy-policy-intro">
            This policy explains how Madurai School Education Commission collects, uses, and protects the personal information of students, parents, educators, and visitors.
          </p>
        </div>

        <p>
          <strong>Madurai School Education Commission</strong> cares about your privacy. We collect and use personal
          information only as needed to deliver our services, websites and mobile applications, and to communicate with you about the same,
          or as you have requested (collectively, our “Services”). Your personal information includes information such as:
        </p>

        <ul className="privacy-policy-list">
          <li>Name</li>
          <li>Address</li>
          <li>Telephone number</li>
          <li>Email address</li>
          <li>Candidate information (for job applicants)</li>
          <li>Other data collected that could directly or indirectly identify you.</li>
        </ul>

        <p>
          Our Privacy Policy explains how and why we use your personal information that we collect, and how you can access,
          update or otherwise take control of your personal information. We have also included answers to common questions,
          quick links for managing your settings, and definitions for key terms used in this Privacy Policy.
        </p>

        <p>
          If you have questions about our practices or any of your rights described below, you may reach our dedicated team by
          contacting us at <a href="mailto:coordinator@mduschooled.in">coordinator@mduschooled.in</a>.
          This inbox is actively monitored so we can deliver an experience you can confidently trust.
        </p>

        <h3>What information we collect, how we collect it, and why</h3>
        <p>
          Much of what you likely consider personal information is collected directly from you when you:
        </p>
        <ul className="privacy-policy-list">
          <li>
            create an account or use any of our Services (for example, billing information such as name, address, and phone number);
          </li>
          <li>request assistance from our support team (for example, phone number);</li>
          <li>complete contact forms or request newsletters or other information from us (for example, email, phone number); or</li>
          <li>participate in surveys, apply for a job, or otherwise join activities we promote that may require information about you.</li>
        </ul>

        <p>
          We also collect additional information when delivering our Services to ensure necessary and optimal performance.
          These methods of collection may not always be obvious, so we highlight them here.
        </p>

        <p>
          Cookies and similar technologies on our websites and applications allow us to track your browsing behavior,
          such as links last visited and interactions with site features. These technologies also collect data to measure website
          performance and improve our systems, including metadata, log files, page load time, server response time, DNS resolution,
          network routing and server configurations.
        </p>

        <h3>How we utilize information</h3>
        <p>
          We minimize the data we collect and limit its use to only that which is necessary for the Services you request,
          for which we have permission, or for legal and compliance purposes.
        </p>

        <p>
          Delivering, improving, updating and enhancing our Services. We collect various information relating to your use and interactions with our Services.
          We use this information to:
        </p>
        <ul className="privacy-policy-list">
          <li>Improve and optimize the operation and performance of our Services.</li>
          <li>Diagnose problems, identify security or compliance risks, errors, or needed enhancements.</li>
          <li>Detect and prevent fraud and abuse of our Services and systems.</li>
        </ul>

        <p>
          Much of the data collected is aggregated or statistical and not linked to personal information.
        </p>

        <h3>Sharing with trusted third parties</h3>
        <p>
          We may share your personal information with affiliated companies, third parties that help integrate services,
          and trusted service providers who perform services on our behalf, such as:
        </p>
        <ul className="privacy-policy-list">
          <li>Processing payments</li>
          <li>Communicating with you by email or surveys</li>
          <li>Customer relationship management</li>
          <li>Security, risk management and compliance</li>
          <li>Recruiting support and related services</li>
        </ul>

        <p>
          These third parties agree not to share, use, or retain your personal information for any purpose other than
          providing the services they perform for us.
        </p>

        <h3>Communicating with you</h3>
        <p>
          We may contact you directly or through a third party regarding products or services you have signed up for or purchased.
          We may also contact you with offers for additional services if you have given consent or where permitted by law.
        </p>
        <ul className="privacy-policy-list">
          <li>Email</li>
          <li>Text (SMS) messages</li>
          <li>Telephone calls</li>
          <li>Messenger applications (such as WhatsApp)</li>
          <li>Automated phone calls or text messages</li>
        </ul>

        <p>
          You may update your subscription preferences by signing into your account and visiting your account settings.
        </p>

        <h3>Transfer of personal information abroad</h3>
        <p>
          If you use our Services from a country other than where our servers are located, your personal information may be transferred
          across borders only when necessary for performance of the contract, when we have your consent, or subject to appropriate
          contractual protections.
        </p>

        <h3>Compliance with legal, regulatory and law enforcement requests</h3>
        <p>
          We cooperate with government, law enforcement officials and private parties to enforce and comply with the law.
          We may disclose information when necessary to respond to legal process, protect our rights or safety, or prevent illegal activity.
        </p>

        <h3>How we secure, store and retain your data</h3>
        <p>
          We follow accepted standards to store and protect the personal information we collect, including encryption when appropriate.
        </p>

        <p>
          We retain personal information only as long as necessary to provide the Services you request and thereafter for lawful
          business and recordkeeping purposes.
        </p>
        <ul className="privacy-policy-list">
          <li>Mandated by law, contract or business obligations.</li>
          <li>For preserving, resolving, defending or enforcing our legal and contractual rights.</li>
          <li>To maintain accurate business and financial records.</li>
        </ul>

        <p>
          If you have questions about security or retention, contact us at <a href="mailto:coordinator@mduschooled.in">coordinator@mduschooled.in</a>.
        </p>

        <h3>How you can access, update or delete your data</h3>
        <p>
          To access, view, update, delete or port your personal information, or update your subscription preferences, sign into your account
          and visit your account settings.
        </p>

        <p>
          If you request deletion and the information is necessary for the Services you purchased, the request will be honored only to the extent
          it is no longer needed for the Services or legal obligations.
        </p>

        <p>
          If you cannot use your account settings, please contact us by one of the methods described in the Contact Us section below.
        </p>

        <h3>Age restrictions</h3>
        <p>
          Our Services are intended for individuals over the age of 18 and are not designed for children under 18.
          If you learn that someone under 18 has provided us with personal information, please contact us.
        </p>

        <h3>Non-Discrimination</h3>
        <p>
          We will not discriminate against you for exercising any privacy rights. Unless permitted by law, we will not:
        </p>
        <ul className="privacy-policy-list">
          <li>Deny you goods or services.</li>
          <li>Charge different prices, rates or impose penalties.</li>
          <li>Provide a different level or quality of goods or services.</li>
          <li>Suggest a different price, rate, or quality of goods and services.</li>
        </ul>

        <h3>Changes to this policy</h3>
        <p>
          We reserve the right to modify this Privacy Policy at any time. Changes will be posted here and where appropriate,
          so you are aware of what information we collect, how we use it, and when we disclose it.
        </p>

        <p>
          If we make material changes, we will notify you here, by email, or with a notice on our home page at least thirty (30) days before implementation.
        </p>

        <h3>Contact us</h3>
        <p>
          If you have questions or complaints about our Privacy Policy, you may contact our Office of the Data Protection Officer
          by email at <a href="mailto:coordinator@mduschooled.in">coordinator@mduschooled.in</a>.
        </p>

        <p>In the alternative, you may contact us by either of the following means:</p>
        <ul className="privacy-policy-list">
          <li>By Email: <a href="mailto:coordinator@mduschooled.in">coordinator@mduschooled.in</a></li>
          <li>By Phone: <a href="tel:+919789099422">+91-9789099422</a></li>
        </ul>

        <p>We will respond to all requests, inquiries or concerns within thirty (30) days.</p>
      </div>

      <style>{`
        .privacy-policy-page {
          background: #eef4fb;
          min-height: 100vh;
          padding: 80px 16px;
        }
        .privacy-policy-card {
          max-width: 920px;
          margin: 0 auto;
          background: #ffffff;
          border-radius: 32px;
          border: 1px solid rgba(148, 163, 184, 0.18);
          box-shadow: 0 32px 80px rgba(15, 23, 42, 0.08);
          padding: 56px;
        }
        .privacy-policy-header h2 {
          font-size: 2.6rem;
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.03em;
          margin-bottom: 0.65rem;
          line-height: 1.1;
        }
        .privacy-policy-revised {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 1rem;
          text-align: center;
        }
        .privacy-policy-intro {
          max-width: 760px;
          margin: 0 auto;
          color: #475569;
          font-size: 1.05rem;
          line-height: 1.9;
          text-align: justify;
          margin-bottom: 1.8rem;
        }
        .privacy-policy-card {
          text-align: left;
        }
        .privacy-policy-card p,
        .privacy-policy-card li {
          color: #334155;
          line-height: 1.85;
          font-size: 1rem;
          margin-bottom: 1rem;
          text-align: justify;
        }
        .privacy-policy-list {
          text-align: left;
          list-style: disc outside;
          padding-left: 1.3rem;
          margin-bottom: 1.4rem;
        }
        .privacy-policy-list li {
          margin-bottom: 0.85rem;
        }
        .privacy-policy-card h3 {
          color: #0f172a;
          margin-top: 2.5rem;
          margin-bottom: 1rem;
          font-size: 1.55rem;
          font-weight: 700;
          letter-spacing: -0.02em;
        }
        .privacy-policy-list {
          list-style: disc outside;
          padding-left: 1.3rem;
          margin-bottom: 1.4rem;
        }
        .privacy-policy-list li {
          margin-bottom: 0.85rem;
        }
        .privacy-policy-card a {
          color: #2563eb;
          text-decoration: none;
          font-weight: 600;
        }
        .privacy-policy-card a:hover {
          text-decoration: underline;
        }
        .privacy-policy-card strong {
          color: #0f172a;
        }
        @media (max-width: 991px) {
          .privacy-policy-card {
            padding: 40px 28px;
          }
        }
        @media (max-width: 767.98px) {
          .privacy-policy-card {
            padding: 30px 20px;
            border-radius: 24px;
          }
          .privacy-policy-header h2 {
            font-size: 2rem;
          }
          .privacy-policy-intro {
            font-size: 1rem;
            margin-bottom: 1.6rem;
          }
        }
      `}</style>
    </section>
  );
}
